document.addEventListener('DOMContentLoaded', function() {
  // Only run on mobile devices
  if (window.innerWidth <= 768) {
    initMobileSlider();
  }
});

function initMobileSlider() {
  // Try to find the element by ID first, then by class as fallback
  let featuresGrid = document.getElementById('featuresGrid');
  if (!featuresGrid) {
    featuresGrid = document.querySelector('.features-grid');
  }
  
  // Check if element exists before proceeding
  if (!featuresGrid) {
    console.warn('Features grid element not found');
    return;
  }
  
  const featureItems = featuresGrid.querySelectorAll('.feature-item');
  
  // Only proceed if we have items
  if (featureItems.length === 0) {
    console.warn('No feature items found');
    return;
  }
  
  // Remove slider-ready class if it exists (for resize events)
  featuresGrid.classList.remove('slider-ready');
  
  // Clone all items to create seamless infinite scroll
  featureItems.forEach(item => {
    const clone = item.cloneNode(true);
    featuresGrid.appendChild(clone);
  });
  
  // Wait a brief moment to ensure DOM is updated, then start animation
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      featuresGrid.classList.add('slider-ready');
    });
  });
  
  // Optional: Add touch/swipe support to pause animation
  let isTouch = false;
  
  featuresGrid.addEventListener('touchstart', function() {
    isTouch = true;
    this.style.animationPlayState = 'paused';
  });
  
  featuresGrid.addEventListener('touchend', function() {
    if (isTouch) {
      setTimeout(() => {
        this.style.animationPlayState = 'running';
      }, 1000); // Resume after 1 second
    }
    isTouch = false;
  });
}

// Re-initialize on window resize (in case user rotates device)
let resizeTimeout;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    if (window.innerWidth <= 768) {
      let featuresGrid = document.getElementById('featuresGrid');
      if (!featuresGrid) {
        featuresGrid = document.querySelector('.features-grid');
      }
      
      if (!featuresGrid) return;
      
      // Remove existing clones (anything beyond the first 4 items)
      const allItems = featuresGrid.querySelectorAll('.feature-item');
      if (allItems.length > 4) {
        for (let i = 4; i < allItems.length; i++) {
          allItems[i].remove();
        }
      }
      
      // Re-initialize the slider
      initMobileSlider();
    }
  }, 250); // Debounce resize events
});